/** Human-readable label for a permission module code (e.g. email_extractor → Email Extractor). */
export function formatModuleLabel(code) {
  return String(code || '')
    .split('_')
    .filter(Boolean)
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
    .join(' ');
}
